"use client";

import { api } from "@convex/_generated/api";
import { Authenticated, useQuery } from "convex/react";

export function UserInfo() {
  return (
    <Authenticated>
      <UserInfoContent />
    </Authenticated>
  );
}

function UserInfoContent() {
  const user = useQuery(api.users.queries.current);

  if (!user) {
    return null;
  }

  const displayName =
    user.username || user.first_name || user.last_name || "User";

  return (
    <div className="flex items-center gap-2">
      <span className="font-mono text-[#8B9297] text-xs tracking-wide">
        Welcome, {displayName}
        {!user.username && (
          <span className="ml-1 text-[#F5A23E]">(Please set username)</span>
        )}
      </span>
    </div>
  );
}
